export const LIST_PACKAGE = 'LIST_PACKAGE';
export const DETAIL_PACKAGE = 'DETAIL_PACKAGE';